import { Injectable } from '@angular/core';
import { RoutesConfig } from '@ieApp/routes.config';
import { UserType } from 'shared-general-libs/type/user';
import { NAV_MENU } from '@ieCore/consts/nav-menu.consts';
import { UserService } from '@ieCore/services/user.service';
import logger from '@ieShared/utils/logger.utils';

type RoutesConfigType = typeof RoutesConfig;
type RouteFunction = RoutesConfigType[keyof RoutesConfigType];

@Injectable({
  providedIn: 'root',
})
export class NavService {
  public to = RoutesConfig;

  constructor(private userService: UserService) {}

  static get(routeFunc: RouteFunction) {
    const urlArr = routeFunc();
    return urlArr[urlArr.length - 1];
  }

  getRouteByUserTypeAndPermission(
    userType: UserType,
    userPermissions?: string[],
  ) {
    const menuItems = NAV_MENU[userType];

    if (userPermissions === undefined) {
      logger.error('User permissions are not defined');
      return;
    }

    for (const item of menuItems) {
      if (!this.userService.checkForPermission(userPermissions, item.permission)) {
        continue;
      }

      // A top-level item with its own route is a direct landing target.
      if (item.route) {
        return item.route().join('/');
      }

      // A routeless parent (e.g. Plan, Track) navigates only through a child,
      // so descend to the first child this user can actually access.
      const child = item.children?.find((c) =>
        this.userService.checkForPermission(userPermissions, c.permission),
      );
      if (child) {
        return child.route().join('/');
      }

      // Permitted parent with no accessible routed child: keep scanning the
      // remaining menu instead of crashing on an undefined route.
    }

    logger.error('No accessible route found for user');
    return;
  }
}
